export default __webpack_public_path__ + "static/media/herkit.284ef24d.png";